import axios from '../utils/request'
import store from '../store'
const accountId = () => store.getters.accountId

export const getAccountNumbers = () => {
  return axios({
    url: `/business/exporters/${accountId()}`,
    params: {
      include: ['analytics', 'relationship_manager', 'scf', 'plan']
    }
  })
}

export const getUserAnalytics = () => {
  return axios({
    url: `/business/exporters/${accountId()}`,
    params: {
      include: ['analytics']
    }
  })
}

export const getUserAccountDetails = () => {
  return axios({
    url: `/business/exporters/${accountId()}`,
    params: {
      include: ['scf', 'plan']
    }
  })
}

export const fetchPendingInvoices = () => {
  return axios({
    url: `/business/exporters/${accountId()}/view/pending_invoices`,
    params: {
      limit: 5
    },
    progressBar: true
  })
}

export const fetchPendingPayments = () => {
  return axios({
    url: `/business/exporters/${accountId()}/view/pending_payments`,
    params: {
      limit: 5
    },
    progressBar: true
  })
}

export const getInvoiceData = () => {
  return axios({
    url: `/business/exporters/${accountId()}/view/invoices_stage_counters`
  })
}

export const fetchTransactionsSummary = () => {
  return axios({
    url: `/business/exporters/${accountId()}/view/scf_transactions_summary`,
    progressBar: true
  })
}

export const fetchBusinessAccount = (params) => {
  return axios({
    url: `/business/accounts/${accountId()}`,
    params
  })
}

export const pricingBannerInteraction = (data) => {
  return axios({
    url: `/interaction_metadata`,
    method: 'POST',
    data
  })
}

export default {
  getAccountNumbers,
  getUserAnalytics,
  getUserAccountDetails,
  fetchPendingInvoices,
  fetchPendingPayments,
  getInvoiceData,
  fetchTransactionsSummary,
  fetchBusinessAccount,
  pricingBannerInteraction
}
